export default __webpack_public_path__ + "static/media/icon-ts.b245770f.png";